import * as core from '../../../../../../../core'

import { query } from './outcome-explore.query'
export const RESOURCE = {
  payload: {
    alias: 'summit:outcome-explore',
    content: {
      root: {
        elements: [
          {
            content: {
              row: {
                elements: [
                  {
                    content: {
                      column: {
                        elements: [
                          {
                            content: {
                              row: {
                                elements: [
                                  {
                                    content: {
                                      widget: {
                                        widget: {
                                          alias:
                                            'summit.outcome-explore-general',
                                        },
                                      },
                                    },
                                    span: 6,
                                  },
                                  {
                                    content: {
                                      widget: {
                                        widget: {
                                          alias:
                                            'summit.outcome-explore-employees',
                                        },
                                      },
                                    },
                                    span: 6,
                                  },
                                ],
                              },
                            },
                            height: 200,
                          },
                          {
                            content: {
                              widget: {
                                widget: {
                                  alias: 'summit.outcome-explore-external-src',
                                },
                              },
                            },
                            height: 200,
                          },
                          // TODO: add more widgets here if needed
                        ],
                      },
                    },
                    span: 8,
                  },
                  {
                    content: {
                      column: {
                        elements: [
                          {
                            content: {
                              widget: {
                                widget: {
                                  alias: 'summit.outcome-explore-metrics',
                                },
                              },
                            },
                            height: 200,
                          },
                          // TODO: add more widgets here if needed
                        ],
                      },
                    },
                    span: 4,
                  },
                ],
              },
            },
            height: 800,
          },
        ],
      },
    },
    description: 'Summit Outcome Explore Page',
    name: 'summit.outcome.explore',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicPage,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicPage>
